<template>
	<div>
		<div class="crumbs">
			<el-breadcrumb separator="/">
				<el-breadcrumb-item>
					<i class="el-icon-lx-cascades"></i> 订单列表
				</el-breadcrumb-item>
			</el-breadcrumb>
		</div>
		<div class="container">
			<div class="handle-box">
				<el-input placeholder="订单编码" class="handle-input mr10" v-model="orderNum" clearable></el-input>
				<el-select v-model="state" placeholder="请选择" clearable>
					<el-option v-for="item in stateList" :key="item.value" :label="item.name" :value="item.value">
					</el-option>
				</el-select>
				<!-- <el-date-picker v-model="value2" type="datetimerange" align="right" :start-placeholder="startTime"
					style="margin-right: 10px;" :end-placeholder="endTime" @change='changeTime'>
				</el-date-picker> -->
				<el-button type="primary" icon="el-icon-search" @click="handleSearch">搜索</el-button>
				<!-- <el-button type="primary" icon="el-icon-circle-plus-outline" @click="createPerson">创建订单</el-button> -->
			</div>
			<el-table :data="pingjiList" border class="table" ref="multipleTable" header-cell-class-name="table-header"
				style="width: 100%">
				<el-table-column prop="OrderNum" label="订单编码" align="center" min-width="300"></el-table-column>
				<!-- <el-table-column prop="Name" label="订单名称" align="center" min-width="200"></el-table-column> -->
				<el-table-column prop="State" label="订单状态" width="90" align="center">
					<template #default="scope">
						<div v-for="(item) in stateList" :key="item">
							<el-tag v-if="scope.row.State==item.value">
								{{item.name}}
							</el-tag>
						</div>
					</template>
				</el-table-column>
				<el-table-column prop="CreateTypeName" label="订单类型" align="center" min-width="200"></el-table-column>
				<!-- <el-table-column prop="CreateName" label="创建人" align="center" min-width="200"></el-table-column> -->
				<el-table-column prop="MemberPhone" label="会员手机号" align="center" min-width="200"></el-table-column>
				<el-table-column prop="kuaping" label="是否快评" align="center" min-width="200"></el-table-column>
				<el-table-column prop="MemberName" label="会员" align="center" min-width="120"></el-table-column>
				<el-table-column prop="ExpressCompany" label="快递公司" align="center" min-width="150"></el-table-column>
				<el-table-column prop="TrackingNum" label="快递单号" align="center" min-width="200"></el-table-column>
				<el-table-column prop="AddTime" label="创建时间" align="center" min-width="200"></el-table-column>
				<el-table-column fixed="right" label="操作" min-width="400" align="center" style="background-color: red;">
					<template #default="scope">
						<el-button @click="handleClick(scope.row)" type="text">查看</el-button>
						<el-button @click="PriceBtn(scope.row)" type="text" icon="el-icon-coin"
							:disabled="scope.row.State=='1'||scope.row.State=='2'?false:true">核算价格</el-button>
						<el-button type="text" icon="el-icon-edit" @click="handleEdit(scope.$index, scope.row)"
							:disabled="scope.row.State=='0'?true:false">编辑
						</el-button>
						<!-- <el-button type="text" icon="el-icon-upload2" @click="photoBtn(scope.row)">上传照片
						</el-button> -->
						<el-button type="text" @click="lookGoods(scope.row)"
							:disabled="scope.row.State=='1'?false:true">创建商品
						</el-button>
						<el-button type="text" icon="el-icon-delete-solid" @click="delleteBtn(scope.row)"
							style="color: red;" v-if="scope.row.State==1||scope.row.State==2?true:false">删除订单
						</el-button>
					</template>
				</el-table-column>
			</el-table>
			<div class="pagination">
				<el-pagination background layout="total, prev, pager, next" :current-page="pageIndex"
					:page-size="pageSize" :total="pageTotal" @current-change="handlePageChange"></el-pagination>
			</div>


			<!-- 创建商品弹出框-->
			<el-dialog :title="title" v-model="createGoods" width="30%">
				<el-form label-width="100px" ref="ruleForm2" :model="ruleForm2" :rules="rules2">
					<el-form-item label="商品标签码" prop="QRFont">
						<el-input v-model="ruleForm2.QRFont" :disabled="false" ></el-input>
					</el-form-item>
					<el-form-item label="商品名称" prop="Name">
						<el-input v-model="ruleForm2.Name" :disabled="isdisabled"></el-input>
					</el-form-item>
					<el-form-item label="类别名称" prop="CategoryId">
						<el-select v-model="ruleForm2.CategoryId" clearable placeholder="请选择类别名称" @change='changeClass'
							:disabled="isdisabled">
							<el-option v-for="item in classList" :key="item.Id" :label="item.Name" :value="item.Id">
							</el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="系列名称" prop="SerieId">
						<el-select v-model="ruleForm2.SerieId" clearable placeholder="请选择系列名称" :disabled="isdisabled">
							<el-option v-for="item in serList" :key="item.Id" :label="item.Name" :value="item.Id">
							</el-option>
						</el-select>
					</el-form-item>
				</el-form>
				<template #footer>
					<span class="dialog-footer">
						<el-button @click="createGoods = false">取 消</el-button>
						<el-button type="primary" @click="createBtn('ruleForm2')">确 定</el-button>
					</span>
				</template>
			</el-dialog>

			<!-- 价格弹出框-->
			<el-dialog :title="title" v-model="isprice" width="30%">
				<el-form label-width="100px" ref="ruleForm" :model="ruleForm" :rules="rules">
					<el-form-item label="订单价格" prop="Price">
						<el-input v-model="ruleForm.Price" :disabled="isdisabled" :maxlength="8"
							onkeypress="return(/[\d]/.test(String.fromCharCode(event.keyCode)))"></el-input>
					</el-form-item>
				</el-form>
				<template #footer>
					<span class="dialog-footer">
						<el-button @click="isprice = false">取 消</el-button>
						<el-button type="primary" @click="saveEdit('ruleForm')">确 定</el-button>
					</span>
				</template>
			</el-dialog>

			<!-- 编辑弹出框 查看弹出框-->
			<el-dialog :title="title" v-model="editVisible" width="30%">
				<el-form label-width="100px" ref="ruleForm" :model="ruleForm" :rules="rules">
					<el-form-item label="订单编码" prop="OrderNum">
						<el-input v-model="ruleForm.OrderNum" disabled>
						</el-input>
					</el-form-item>
					<el-form-item label="经销商">
						<el-select v-model="ruleForm.AgencyUserId" placeholder="请选择经销商" style="width: 100%;" disabled
							clearable>
							<el-option :label="item.Name" :value="item.Id" v-for="item in distributorList"
								:key="item.Id">
							</el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="是否快评" prop="SpeedNum">
						<el-select v-model="ruleForm.SpeedNum" placeholder="请选择快评" style="width: 100%;" disabled
							clearable>
							<el-option :label="item.Name" :value="item.Id" v-for="item in kuaipingList" :key="item.Id">
							</el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="送评数量" prop="ExpressCompany">
						<el-input v-model="ruleForm.Tag" disabled>
						</el-input>
					</el-form-item>
					<el-form-item label="快递公司" prop="ExpressCompany">
						<el-input v-model="ruleForm.ExpressCompany" disabled>
						</el-input>
					</el-form-item>
					<el-form-item label="快递单号" prop="TrackingNum">
						<el-input v-model="ruleForm.TrackingNum" disabled>
						</el-input>
					</el-form-item>
					<el-form-item label="订单状态" prop="State" v-if="title=='创建订单'&& ruleForm.State!=1?false:true">
						<el-select v-model="ruleForm.State" placeholder="请选择订单状态" style="width: 100%;"
							:disabled="title=='编辑'&& ruleForm.State!=1?false:true" clearable>
							<el-option :label="item.name" :value="item.value" v-for="item in stateList2" :key="item.Id">
							</el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="订单价格" prop="Price" v-if="title=='查看评级订单'">
						<el-input v-model="ruleForm.Price" :disabled="true">
						</el-input>
					</el-form-item>
					<div class="scorro" v-if="title=='编辑'||title=='创建订单'|| photoList == ''?false:true">
						<div class="demo-image__lazy">
							<el-image v-for="Url in photoList" :key="Url" :src="Url.Url" lazy></el-image>
						</div>
					</div>
					<el-form-item label="备注" style="min-height: 50px;">
						<el-input type="textarea" v-model="ruleForm.Remark" disabled :maxlength="200">
						</el-input>
					</el-form-item>
					<el-divider content-position="center">收货人信息</el-divider>
					<el-form-item label="收货人姓名" prop="Name">
						<el-input v-model="ruleForm.Name" disabled type="text"></el-input>
					</el-form-item>
					<el-form-item label="收货人手机号" prop="Phone">
						<el-input v-model="ruleForm.Phone" disabled type="text" :maxlength="11">
						</el-input>
					</el-form-item>
					<el-form-item label="地区" prop="Region">
						<el-select v-model="ruleForm.Region" placeholder="请选择地区" style="width: 100%;" disabled
							clearable>
							<el-option :label="item" :value="item" v-for="item in provinceList" :key="item">
							</el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="收货地址" prop="Address">
						<el-input v-model="ruleForm.Address" disabled></el-input>
					</el-form-item>

					<el-divider content-position="center">会员信息</el-divider>
					<el-form-item label="会员姓名" prop="MemberName">
						<el-input v-model="ruleForm.MemberName" disabled type="text">
						</el-input>
					</el-form-item>
					<el-form-item label="联系电话" prop="MemberPhone">
						<el-input v-model="ruleForm.MemberPhone" disabled type="text" :maxlength="11"
							@change='changePhone'></el-input>
					</el-form-item>

					<el-divider content-position="center" v-if="ruleForm.State==5?true:false">回寄信息</el-divider>
					<el-form-item label="快递公司" prop="BackExpressCompany" v-if="ruleForm.State==5?true:false">
						<el-input v-model="ruleForm.BackExpressCompany" :disabled='isdisabled' type="text"></el-input>
					</el-form-item>
					<el-form-item label="快递单号" prop="BackTrackingNum" v-if="ruleForm.State==5?true:false">
						<el-input v-model="ruleForm.BackTrackingNum" :disabled='isdisabled' type="text"></el-input>
					</el-form-item>

				</el-form>
				<template #footer>
					<span class="dialog-footer">
						<el-button @click="editVisible = false">取 消</el-button>
						<el-button type="primary" @click="saveEdit('ruleForm')"
							:disabled="ruleForm.MemberUserId!=''?false:true">确 定</el-button>
					</span>
				</template>
			</el-dialog>
		</div>
	</div>
</template>

<script>
	import axios from 'axios'
	import qs from 'qs'
	export default {
		data() {
			return {
				createGoods: false,
				provinceList: ['北京市', '广东省', '山东省', '江苏省', '河南省', '上海市', '河北省', '浙江省',
					'香港特别行政区', '陕西省', '湖南省', '重庆市', '福建省', '天津市', '云南省', '四川省', '广西壮族自治区', '安徽省',
					'海南省', '江西省', '湖北省', '山西省', '辽宁省', '台湾省', '黑龙江', '内蒙古自治区', '澳门特别行政区', '贵州省', '甘肃省',
					'青海省', '新疆维吾尔自治区', '西藏区', '吉林省', '宁夏回族自治区'
				],
				title: '',
				goodsLsit: [],
				pingjiList: [],
				ruleForm: [],
				ruleForm2: [],
				token: localStorage.getItem('access_token'),
				roleid: localStorage.getItem('RoleId'),
				Id: localStorage.getItem('Id'),
				pageSize: 5,
				pageIndex: 1,
				pageTotal: '',
				editVisible: false,
				rules2: {
					CategoryId: [{
						required: true,
						message: '请选择分类名称',
						trigger: 'change'
					}],
					Name: [{
						required: true,
						message: '请输入商品名称',
						trigger: 'blur'
					}],
					SerieId: [{
						required: true,
						message: '请选择系列名称',
						trigger: 'change'
					}],
				},
				rules: {
					OrderNum: [{
						required: true,
						message: '请输入订单编号',
						trigger: 'blur'
					}],

					Name: [{
						required: true,
						message: '请输入订单名称',
						trigger: 'blur'
					}],
					Region: [{
						required: true,
						message: '请输入地区',
						trigger: 'blur'
					}],
					Address: [{
						required: true,
						message: '请输入详细地址',
						trigger: 'blur'
					}],
					MemberUserId: [{
						required: true,
						message: '请选择会员',
						trigger: 'change'
					}],
					Phone: [{
						required: true,
						message: '请输入收件人手机号',
						trigger: 'blur'
					}, {
						pattern: /^1[0123456789]\d{9}$/,
						message: '目前只支持中国大陆的手机号码',
						trigger: "blur"
					}],
					AgencyUserId: [{
						required: true,
						message: '请选择经销商',
						trigger: 'change'
					}],
					BackExpressCompany: [{
						required: true,
						message: '请填写快递公司',
						trigger: 'blur'
					}],
					BackTrackingNum: [{
						required: true,
						message: '请选择快递单号',
						trigger: 'blur'
					}],
					Price: [{
						required: true,
						message: '价格不可以为空',
						trigger: 'blur'
					}, {
						required: true,
						validator: this.isNumber,
						trigger: 'blur'
					}],
				},
				isdisabled: false,
				orderNum: '',
				value2: [],
				memberList: [], //会员列表
				distributorList: [], //经销商列表
				kuaipingList: [{
						Id: 1,
						Name: '普通'
					},
					{
						Id: 2,
						Name: '加急'
					}
				],
				startTime: '', //开始时间
				endTime: '', //结束时间
				stateList: [{
					name: '已取消',
					value: 0
				}, {
					name: '待确认',
					value: 1
				}, {
					name: '待付款',
					value: 2
				}, {
					name: '评级中',
					value: 3
				}, {
					name: '已发货',
					value: 5
				}, {
					name: '已完成',
					value: 6
				}],
				state: '',
				isprice: false,
				isphoto: false,
				photoList: [],
				showphoto: false,
				stateList2: [{
					name: '已取消',
					value: 0
				}, {
					name: '待确认',
					value: 1
				}, {
					name: '待付款',
					value: 2
				}, {
					name: '已付款',
					value: 3
				}, {
					name: '已发货',
					value: 5
				}, {
					name: '已完成',
					value: 6
				}],
				classList: [],
				serList: []
			}
		},
		created() {
			// this.getstate()
			this.getmember()
			this.getdistributor()
			this.getToday()
			this.getData()
			this.getclass()
		},
		methods: {
			//改变分类改变系列
			changeClass(val) {
				console.log(val)
				axios({
					method: 'get',
					url: this.$store.state.pcurl + "GetSeries?&pageSize=99999" + '&name=' + '' + '&pageIndex=0' +
						'&categoryId=' + val,
					headers: {
						Authorization: 'bearer ' + this.token
					}
				}).then((res) => {
					console.log(res.data.Data)
					if (res.data.Data == '') {
						this.serList = res.data.Data
						this.ruleForm2.SerieId = ''
					} else {
						this.serList = res.data.Data
						this.ruleForm2.SerieId = this.serList[0].Id
					}
				})
			},
			//获取全部分类
			getclass() {
				axios({
					method: 'get',
					url: this.$store.state.pcurl + "GetCategories?&pageSize=99999" + '&name=' + '' +
						'&pageIndex=0',
					headers: {
						Authorization: 'bearer ' + this.token
					}
				}).then((res) => {
					this.classList = res.data.Data
				})
			},
			// updatePhoto(index){
			// 	this.photoList.splice(index, 1)
			// },
			isNumber(rule, value, callback) {
				if (isNaN(value)) {
					callback(new Error("价格必须是数字"))
				} else {
					callback()
				}
			},
			//删除照片
			changePhone(val) {
				console.log(val)
				axios({
					method: 'get',
					url: this.$store.state.pcurl + "GetUserByPhone?Phone=" + val,
					headers: {
						"Authorization": "bearer " + this.token
					}
				}).then((res) => {
					console.log(res.data.Data)
					if (res.data.Data) {
						this.ruleForm.Name = res.data.Data.Name
						this.ruleForm.MemberUserId = res.data.Data.Id
					} else {
						this.ruleForm.Name = ''
						this.ruleForm.MemberUserId = ''
					}
				})
			},
			//创建订单
			createPerson() {
				this.isdisabled = false
				this.photoList = []
				this.ruleForm = []
				this.ruleForm.SpeedNum = this.kuaipingList[0].Id
				this.ruleForm.Region = this.provinceList[0]
				this.editVisible = true
				this.title = '创建订单'
				axios({
					method: 'post',
					url: this.$store.state.pcurl + 'OrderNum',
				}).then((res) => {
					this.ruleForm.OrderNum = res.data.Data
				})
			},
			changeMember(val) {
				axios({
					method: 'get',
					url: this.$store.state.pcurl + "GetUserModel?userId=" + val,
					headers: {
						"Authorization": "bearer " + this.token
					},
				}).then((res) => {
					console.log(res.data.Data)
					this.ruleForm.Phone = res.data.Data.Phone
					this.ruleForm.Address = res.data.Data.Address
					this.ruleForm.Region = res.data.Data.Region
				})
			},
			deletePhoto(index) {
				console.log(index)
				this.photoList.splice(index, 1)
				console.log(this.photoList)
			},
			//图片上传
			beforeAvatarUpload(file) {
				let dian = file.name.lastIndexOf('.')
				let type = file.name.substr(dian + 1)
				const isLt2M = file.size / 1024 / 1024 < 1
				console.log(isLt2M)
				if (this.photoList.length < 6) {
					if (!isLt2M) {
						this.$message.error('上传文件大小不能超过2M!')
					} else if (type != 'xls' && type != 'pdf' && type != 'jpg' && type != 'png' && type != 'xlsx' &&
						type != 'bmp' && type != 'jpeg' &&
						type != 'XLS' && type != 'PDF' && type != 'JPG' && type != 'PNG' && type != 'XLSX' && type !=
						'BMP' && type != 'JPEG') {
						this.$message.error('上传图片必须是 xls / pdf / jpg / png / xlsx / bmp / jpeg 格式!');
					} else {
						let formdata = ''
						formdata = new FormData()
						formdata.append('file', file)
						axios({
							method: 'post',
							url: this.$store.state.pcurl + "UserBillPhotoUpload",
							data: formdata
						}).then((res) => {
							if (res.data.Message == '请求成功') {
								console.log(res.data.Data)
								res.data.Data[0].Url = res.data.Data[0].url
								this.photoList.push(res.data.Data[0])
							}
						})
					}
				} else {
					this.$message.error('最多可以上传 6 张照片!')
				}
			},
			uploadPhoto() {
				this.photoList.forEach((x) => {
					this.ruleForm.Url = x.Url
					axios({
						method: 'post',
						url: this.$store.state.pcurl + "AddBillPhoto",
						headers: {
							"Authorization": "bearer " + this.token
						},
						data: this.ruleForm
					}).then((res) => {
						if (res.data.Message == '请求成功') {
							this.isphoto = false
							this.getData()
							this.$message({
								message: '上传成功!',
								type: 'success'
							});
						}
					})
				})
			},
			// getstate() {
			// 	axios({
			// 		method: 'get',
			// 		url: this.$store.state.url + "GetBillState",
			// 	}).then((res) => {
			// 		res.data.Data.forEach((x)=>{
			// 			if(x.name=='待确认'||x.name=='待付款'||x.name=='已付款_评级中'||x.name=='待发货'||x.name=='已发货_待收货'){

			// 			}
			// 		})
			// 	})
			// },
			getToday() {
				///获取时间
				// let date = new Date()
				// let year = date.getFullYear()
				// let month = date.getMonth() + 1
				// month = month < 10 ? '0' + month : month
				// let startday = date.getDate() - 1
				// startday = startday < 10 ? '0' + startday : startday
				// let endday = date.getDate()
				// endday = endday < 10 ? '0' + endday : endday
				// let hour = date.getHours() + 2
				// hour = hour < 10 ? '0' + hour : hour
				// let min = date.getMinutes()
				// min = min < 10 ? '0' + min : min
				// let sec = date.getSeconds()
				// sec = sec < 10 ? '0' + sec : sec
				// this.startTime = year + '-' + month + '-' + startday + ' ' + hour + ':' + min + ':' + sec
				// this.endTime = year + '-' + month + '-' + endday + ' ' + hour + ':' + min + ':' + sec
			},
			//获取全部会员
			getmember() {
				var token = this.token
				axios({
					method: 'get',
					url: this.$store.state.pcurl + "GetUsers?roleId=" + 'be4e45c7-03cc-45ee-8f00-49c3665819ca' +
						'&pageSize=999999',
					headers: {
						"Authorization": "bearer " + token + ""
					},
				}).then((res) => {
					this.memberList = res.data.Data
				})
			},
			//获取全部经销商
			getdistributor() {
				var token = this.token
				axios({
					method: 'get',
					url: this.$store.state.pcurl + "GetUsers?roleId=" + 'a591fe1e-7da8-4124-8912-b5af5282d57a' +
						'&pageSize=999999',
					headers: {
						"Authorization": "bearer " + token + ""
					},
				}).then((res) => {
					this.distributorList = res.data.Data
				})
			},

			//获取评级列表
			getData() {
				let createUserId = ''
				if (this.roleid == 'a591fe1e-7da8-4124-8912-b5af5282d57a') {
					createUserId = this.Id
				}
				this.pingjiList = []
				var pageIndex = this.pageIndex - 1
				axios({
					method: 'get',
					url: this.$store.state.pcurl + "GetBills?startTime=" + this.startTime +
						'&endTime=' + this.endTime + '&state=' + this.state + '&pageIndex=' + pageIndex +
						'&pageSize=' +
						this.pageSize + '&createUserId=' + createUserId + '&orderNum=' + this.orderNum,
					headers: {
						Authorization: 'bearer ' + this.token
					}
				}).then((res) => {
					if (res.data.Message == '请求成功') {
						this.pingjiList = res.data.Data
						this.pageTotal = res.data.Count
						console.log(this.pingjiList)
						this.pingjiList.forEach((x) => {
							x.AddTime = x.AddTime.replace('T', ' ')
							switch (x.CreateType) {
								case 1:
									x.CreateTypeName = '会员创建';
									break;
								case 2:
									x.CreateTypeName = '客服创建';
									break;
								case 3:
									x.CreateTypeName = '经销商创建';
									break;
								case 4:
									x.CreateTypeName = '总评创建';
									break;
							}


							if (x.SpeedNum == 1) {
								x.kuaping = "普通"
							} else {
								x.kuaping = "加急"
							}
							switch (x.State) {
								case 1:
									x.StateName = '待确认';
									break;
								case 2:
									x.StateName = '待付款';
									break;
								case 3:
									x.StateName = '评级中';
									break;
								case 4:
									x.StateName = '一人已打分';
									break;
								case 5:
									x.StateName = '二人已打分';
									break;
								case 6:
									x.StateName = '三人已打分';
									break;
								case 10:
									x.StateName = '已发货';
									break;
							}

							if (x.MemberUserId) {
								axios({
									method: 'get',
									url: this.$store.state.pcurl + "GetUserModel?userId=" + x
										.MemberUserId,
									headers: {
										Authorization: 'bearer ' + this.token
									}
								}).then((res) => {
									x.MemberName = res.data.Data.Name
									x.MemberPhone = res.data.Data.Phone
								})
							}
							// if (x.CreateUserId) {
							// 	axios({
							// 		method: 'get',
							// 		url: this.$store.state.pcurl + "GetUserModel?userId=" + x
							// 			.CreateUserId,
							// 		headers: {
							// 			Authorization: 'bearer ' + this.token
							// 		}
							// 	}).then((CreateUserId) => {
							// 		x.CreateName = CreateUserId.data.Data.Name + '创建'
							// 	})
							// }
						})
					} else {
						this.$message.error('评级列表获取失败')
					}
				})
			},
			//监听时间变化
			changeTime() {
				let start = JSON.stringify(this.value2[0])
				let end = JSON.stringify(this.value2[1])
				this.startTime = JSON.parse(start).replace(/T|\.\d{3}Z/g, " ")
				this.endTime = JSON.parse(end).replace(/T|\.\d{3}Z/g, " ")
				console.log(this.startTime, this.endTime)
			},
			//搜索
			handleSearch() {
				this.pingjiList = []
				this.pageIndex = 1
				this.getData()
			},
			handlePageChange(val) {
				this.pageIndex = val
				this.getData()
			},
			//上传照片
			photoBtn(row) {
				this.title = '上传照片'
				console.log(row)
				this.isphoto = true
				this.photoList = []
				this.ruleForm.BillId = row.Id
				this.ruleForm.Name = row.Name
				this.ruleForm.MemberUserId = row.MemberUserId
				axios({
					method: 'get',
					url: this.$store.state.pcurl + "GetBillPhotos?biilId=" + row.Id,
					headers: {
						"Authorization": "bearer " + this.token
					},
				}).then((res) => {
					console.log(res.data.Data)
					this.photoList = res.data.Data
				})
			},
			//删除订单
			delleteBtn(row) {
				console.log(row)

				this.$confirm('您确认是否要删除吗?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {

					axios({
						method: 'post',
						url: this.$store.state.pcurl + "DeleteBill?billId=" + row.Id,
						headers: {
							"Authorization": "bearer " + this.token
						},
					}).then((res) => {
						if (res.data.Data) {
							this.$message({
								type: 'success',
								message: '删除成功!'
							});
							this.getData()
						} else {
							this.$message.error('该订单下有关联数据，无法删除!')
						}
					})


				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消删除'
					});
				});


				// axios({
				// 	method: 'get',
				// 	url: this.$store.state.pcurl + "GetCollectibles?orderNum=" + row.OrderNum,
				// 	headers: {
				// 		"Authorization": "bearer " + this.token
				// 	},
				// }).then((res) => {
				// 	if (res.data.Data == '') {
				// 		this.$confirm('该订单下没有商品, 是否继续删除?', '提示', {
				// 			confirmButtonText: '确定',
				// 			cancelButtonText: '取消',
				// 			type: 'success'
				// 		}).then(() => {
				// 			axios({
				// 				method: 'post',
				// 				url: this.$store.state.pcurl + "DeleteBill?billId=" + row.Id,
				// 				headers: {
				// 					"Authorization": "bearer " + this.token
				// 				},
				// 			}).then((res) => {
				// 				if (res.data.Message == '请求成功') {
				// 					this.$message({
				// 						type: 'success',
				// 						message: '删除成功!'
				// 					});
				// 					this.getData()
				// 				}
				// 			})
				// 		}).catch(() => {
				// 			this.$message({
				// 				type: 'info',
				// 				message: '已取消删除'
				// 			});
				// 		});
				// 	} else {
				// 		this.$confirm('该订单下有商品, 是否继续?', '提示', {
				// 			confirmButtonText: '确定',
				// 			cancelButtonText: '取消',
				// 			type: 'warning'
				// 		}).then(() => {
				// 			axios({
				// 				method: 'post',
				// 				url: this.$store.state.pcurl + "DeleteBill?billId=" + row.Id,
				// 				headers: {
				// 					"Authorization": "bearer " + this.token
				// 				},
				// 			}).then((res) => {
				// 				if (res.data.Message == '请求成功') {
				// 					this.$message({
				// 						type: 'success',
				// 						message: '删除成功!'
				// 					});
				// 					this.getData()
				// 				}
				// 			})
				// 		}).catch(() => {
				// 			this.$message({
				// 				type: 'info',
				// 				message: '已取消删除'
				// 			});
				// 		});
				// 	}
				// })

			},
			//去往商品信息页面
			lookGoods(row) {
				console.log(row)
				this.ruleForm2 = []
				this.title = '创建商品'
				this.createGoods = true
				this.ruleForm2.MemberUserId = row.MemberUserId
				this.ruleForm2.BillId = row.Id
				axios({
					method: 'post',
					url: this.$store.state.pcurl + 'QRFont',
				}).then((res) => {
					this.ruleForm2.QRFont = res.data.Data
				})
			},
			//核算价格
			PriceBtn(row) {
				this.ruleForm = []
				console.log(row)
				this.title = '核算价格'
				this.isdisabled = false
				axios({
					method: 'get',
					url: this.$store.state.pcurl + "GetBillModel?billId=" + row.Id,
					headers: {
						"Authorization": "bearer " + this.token
					},
				}).then((res) => {
					this.ruleForm = res.data.Data
					this.isprice = true
				})
			},
			//查看
			handleClick(row) {
				this.title = '查看评级订单'
				this.isdisabled = true
				axios({
					method: 'get',
					url: this.$store.state.pcurl + "GetBillModel?billId=" + row.Id,
					headers: {
						"Authorization": "bearer " + this.token
					},
				}).then((res) => {
					console.log(res.data.Data)
					this.ruleForm = res.data.Data
					this.ruleForm.MemberName = row.MemberName
					this.ruleForm.MemberPhone = row.MemberPhone
					this.editVisible = true
				})
				//查看照片
				axios({
					method: 'get',
					url: this.$store.state.pcurl + "GetBillPhotos?biilId=" + row.Id,
					headers: {
						"Authorization": "bearer " + this.token
					},
				}).then((res) => {
					this.photoList = res.data.Data
				})

			},
			// 编辑
			handleEdit(index, row) {
				this.title = '编辑'
				this.isdisabled = false
				// if (row.State == 1 || row.State == 2) {
				// 	this.isdisabled = false
				// } else {
				// 	this.isdisabled = true
				// }
				axios({
					method: 'get',
					url: this.$store.state.pcurl + "GetBillModel?billId=" + row.Id,
					headers: {
						"Authorization": "bearer " + this.token
					},
				}).then((res) => {
					this.ruleForm = res.data.Data
					this.ruleForm.MemberName = row.MemberName
					this.ruleForm.MemberPhone = row.MemberPhone
					this.editVisible = true
				})
			},
			createBtn(ruleForm2) {
				// console.log(this.token)
				var token = this.token
				if (this.title == '创建商品') {
					this.$refs[ruleForm2].validate((valid) => {
						if (valid) {
							this.ruleForm2.AddUserId = this.Id
							this.ruleForm2.CreateType = 2
							this.ruleForm2.State = 1
							console.log(this.ruleForm2)
							axios({
								method: 'post',
								url: this.$store.state.pcurl + "AddCollectiblesPool",
								data: qs.stringify(this.ruleForm2),
								headers: {
									"Authorization": "bearer " + token
								},
							}).then((res) => {
								if (res.data.Message == '请求成功') {
									this.editVisible = false
									this.$message({
										message: '创建成功',
										type: 'success'
									})
									this.getData()
									this.createGoods = false
								} else {
									this.$message.error('创建失败')
								}
							})
						} else {
							console.log('error submit!!');
							return false;
						}
					});
				}
			},
			//保存编辑
			saveEdit(ruleForm) {
				if (this.title == '编辑') {
					this.$refs[ruleForm].validate((valid) => {
						if (valid) {
							axios({
								method: 'post',
								url: this.$store.state.pcurl + "UpdateBill",
								data: this.ruleForm,
								headers: {
									"Authorization": "bearer " + this.token
								},
							}).then((res) => {
								if (res.data.Message == '请求成功') {
									this.editVisible = false
									this.$message({
										message: '修改成功',
										type: 'success'
									})
									this.getData()
								} else {
									this.$message.error('修改失败');
								}
							})
						} else {
							console.log('error submit!!');
							return false;
						}
					});
				} else if (this.title == '创建订单') {
					this.$refs[ruleForm].validate((valid) => {
						if (valid) {

							axios({
								method: 'get',
								url: this.$store.state.pcurl + "GetRoleModel?roleId=" +
									this.roleid,
								headers: {
									"Authorization": "bearer " + this.token
								},
							}).then((res) => {
								switch (res.data.Data.Name) {
									case '会员':
										this.ruleForm.CreateType = 1;
										break;
									case '客服':
										this.ruleForm.CreateType = 2;
										break;
									case '经销商':
										this.ruleForm.CreateType = 3;
										break;
									case '总评':
										this.ruleForm.CreateType = 4;
										break;
								}

								this.ruleForm.CreateUserId = this.Id
								axios({
									method: 'post',
									url: this.$store.state.pcurl + "AddBill",
									data: qs.stringify(this.ruleForm),
									headers: {
										"Authorization": "bearer " + this.token
									},
								}).then((res) => {
									if (res.data.Message == '请求成功') {
										this.editVisible = false
										this.$message({
											message: '创建成功',
											type: 'success'
										})
										console.log(this.ruleForm)
										this.getData()
									} else {
										this.$message.error('创建失败');
									}
								})
							})
						} else {
							console.log('error submit!!');
							return false;
						}
					});
				} else if (this.title == '核算价格') {
					this.$refs[ruleForm].validate((valid) => {
						if (valid) {
							axios({
								method: 'post',
								url: this.$store.state.pcurl + "UpdateBillPrice?billId=" + this.ruleForm
									.Id +
									'&price=' + this.ruleForm.Price + '&userId=' + this.Id,
								headers: {
									"Authorization": "bearer " + this.token
								},
							}).then((res) => {
								if (res.data.Message == '请求成功') {
									this.isprice = false
									this.$message({
										message: '核算价格成功',
										type: 'success'
									})
									this.getData()
								} else {
									this.$message.error('核算价格失败');
								}
							})
						} else {
							console.log('error submit!!');
							return false;
						}
					});
				} else {
					this.editVisible = false
				}
			}
		}
	};
</script>

<style scoped lang="less">
	:deep(.el-divider__text) {
		color: #cecece;
	}

	:deep(.el-upload) {
		width: 56px !important;
		height: 32px;
		border: none;
		line-height: 0;
		margin-left: 50px;
	}

	:deep(.el-image) {
		display: block !important;
		margin-bottom: 30px;
		text-align: center;
	}

	:deep(.el-image__inner) {
		width: 50%;
	}

	.scorro {
		height: 500px;
		overflow: auto;
		border: 3px solid #f5f7fa;
	}

	:deep(.el-upload-list) {
		height: 0px !important;
	}

	.el-select {
		width: 300px;
		margin-right: 10px;
	}

	.handle-box {
		margin-bottom: 20px;
	}

	.handle-select {
		width: 120px;
	}

	.handle-input {
		width: 300px;
		display: inline-block;
	}

	.table {
		width: 100%;
		font-size: 14px;
	}

	.red {
		color: #ff0000;
	}

	.mr10 {
		margin-right: 10px;
	}

	.table-td-thumb {
		display: block;
		margin: auto;
		width: 40px;
		height: 40px;
	}

	:deep(.el-form-item__label) {
		width: 120px !important;
	}

	:deep(.el-form-item__content) {
		margin-left: 120px !important;
	}

	:deep(.el-textarea__inner) {
		min-height: 75px !important;
	}
</style>
